
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import WaterChemicalSupplyPreventiveWorkPopup from './WaterChemicalSupplyPreventiveWorkPopup'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import { ChemicalSupplyDeleteAPI, ChemicalSupplyExportTableDataAPI, ChemicalSupplyTableDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveWorkWaterSupply/ChemicalSupplySlice'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'
import { JunctionNameDataDDL } from '../../../../../../Components/CommonDDL/JunctionNameDataDDL'
import moment from 'moment'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { Loading } from '../../../../../../Helper/Loading'
import { DistributionLineLocationDataDDL } from '../../../../../../Components/CommonDDL/DistributionLineLocationDataDDL'
import { WaterChemicalPreventiveWorkExportData } from './WaterChemicalSupplyPreventiveWorkExportPage'
import { TableNote } from '../../../../../../Components/Note/Note'


export default function ChemicalSupplyPreventiveWorkPage() {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    // console.log(ApiFlag)
    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [IsClear, setIsClear] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [WaterQualityPhPopupShow, setWaterQualityPhPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [WaterChemicalSupplyPreventiveWorkPopupShow, setWaterChemicalSupplyPreventiveWorkPopupShow] = useState()

    const [WardName, setWardName] = useState({
        DDL: [],
        // ID: HWard && HWard ? HWard : '0',
        // Label: WLable && WLable ? WLable : "Select...",
        ID: 0,
        Label: 'Select...'
    })
    const [JunctionNameDDL, setJunctionNameDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    // const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
    const [Date, setDate] = useState(moment().format('YYYY-MM-DD'))

    const date = Month?.ID != 0 && (Month?.ID <= 3 ? moment().month(Month?.ID - 1).format('YYYY-MM-DD') : moment().year(year.ID).month(Month?.ID - 1).date(1).format('YYYY-MM-DD'));
    const [FromDate, setFromDate] = useState(date ? moment(date).startOf('month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(date ? date : moment().format('YYYY-MM-DD'))

    const handleEditOnClick = (item) => {
        setWaterChemicalSupplyPreventiveWorkPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setWaterChemicalSupplyPreventiveWorkPopupShow(false)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            // ID: HWard,
            // Label: WLable,
            ID: 0,
            Label: 'Select...'
        })
        setJunctionNameDDL({
            ...JunctionNameDDL,
            ID: 0,
            Label: 'Select...',
        })
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
        setDate(moment().format('YYYY-MM-DD'))
    }
    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    useEffect(() => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_WS_JunctionID: JunctionNameDDL.ID,
            M_UserID: UserID,
            Flag: 'Grid',
            token: token,
            From: From,
            To: To,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID,
            handleChemicalSupplyExport: handleChemicalSupplyExport
        }
        // if (WardName.ID !== 0) {
        dispatch(ChemicalSupplyTableDataAPI({ data }))
        // }

    }, [IsPost, To, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.ChemicalSupplyTableData)

    const handleChemicalSupplyExport = () => {
        const data = {
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            M_WS_JunctionID: JunctionNameDDL.ID,
            M_UserID: UserID,
            Flag: 'Report',
            token: token,
            From: '1',
            To: '99999',
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        // if (WardName.ID !== 0) {
        dispatch(ChemicalSupplyExportTableDataAPI({ data }))
        // }

    }
    // , [IsPost, isSearch, IsClear])

    const { ExportTableData, isExportLoading } = useSelector(state => state.ChemicalSupplyExportTableData)

    const handleDeleteApi = (item) => {
        const data = {
            T_WS_ChemicalSupplyID: item.t_wS_ChemicalSupplyID,
            T_Distri_WaterChemicalSupplyID: item.t_Distri_WaterChemicalSupplyID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }

        dispatch(ChemicalSupplyDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.ChemicalSupplyDelete)

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='col-8'>
                                <h5 className="mt-2">Chemical Supply</h5>
                            </div>
                            <div className='col-4 mar_add'>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <WaterChemicalPreventiveWorkExportData
                                                ExcelData={ExportTableData}
                                                FromDate={FromDate}
                                                ToDate={ToDate}
                                                name='Chemical Supply'
                                                RoleID={RoleID}
                                            // searchName={searchName}
                                            />
                                    }
                                </div>
                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            <div className="col-lg-2 col-md-4">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>From Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="FromDate"
                                                        value={FromDate}
                                                        onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                    />
                                                </div>

                                            </div>
                                            <div className="col-lg-2 col-md-4">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>To Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="ToDate"
                                                        value={ToDate}
                                                        onChange={(e) => setToDate(e.target.value)}
                                                        min={FromDate}
                                                    />
                                                </div>

                                            </div>
                                            <div className="col-lg-2 col-md-4">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                // HWard={HWard}
                                                // WLable={WLable}
                                                // Flag='ward'
                                                />
                                            </div>

                                            {
                                                (DashProjectTypeId == '6' && RoleID != '16') ?
                                                    <>
                                                        <div className="col-lg-3 col-md-4">
                                                            <DistributionLineLocationDataDDL
                                                                DistributionLineLocationDDL={JunctionNameDDL}
                                                                setDistributionLineLocationDDL={setJunctionNameDDL}
                                                                WardName={WardName}
                                                            // Flag='ward'
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className="col-lg-3 col-md-4">
                                                            <JunctionNameDataDDL
                                                                JunctionNameDDL={JunctionNameDDL}
                                                                setJunctionNameDDL={setJunctionNameDDL}
                                                                WardName={WardName}
                                                            />
                                                        </div>
                                                    </>
                                            }

                                            <div className="col-12 col-md-6 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>

                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive">
                                            <TableNote />
                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Date</th>
                                                        {
                                                            (DashProjectTypeId == '6' && RoleID != '16') ?
                                                                <>
                                                                    <th>Location</th>
                                                                </>
                                                                :
                                                                <>
                                                                    <th>Junction</th>
                                                                </>
                                                        }
                                                        <th>Pipeline</th>
                                                        {
                                                            (DashProjectTypeId == '6' && RoleID != '16') ?
                                                                <th>Water Reading</th>
                                                                :
                                                                <th>Water Reading</th>
                                                        }
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.readingDate ? moment(item.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                                                {
                                                                    (DashProjectTypeId == '6' && RoleID != '16') ?
                                                                        <>
                                                                            <td>{item.locationDetails ? item.locationDetails : '-'}</td>
                                                                        </>
                                                                        :
                                                                        <>
                                                                            <td>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                                                        </>
                                                                }
                                                                <td>{item.pipelineDetails ? item.pipelineDetails : '-'}</td>
                                                                {
                                                                    (DashProjectTypeId == '6' && RoleID != '16') ?
                                                                        <td style={{ textAlign: "right" }}>{item.waterReading ? item.waterReading : '0'}</td>
                                                                        :
                                                                        <td style={{ textAlign: "right" }}>{item.chroline ? item.chroline : '0'}</td>
                                                                }

                                                                <td style={{ textAlign: "center", width: '7%' }}>
                                                                    {
                                                                        (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                            <>
                                                                                <span >

                                                                                    <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        onClick={() => handleEditOnClick(item)}
                                                                                    >
                                                                                    </i>
                                                                                </span>
                                                                                <span>
                                                                                    <DeletePopup
                                                                                        open={DeletePopupShow}
                                                                                        handleDeleteApi={handleDeleteApi}
                                                                                        item={item}
                                                                                    />
                                                                                </span>
                                                                            </>
                                                                            :
                                                                            '-'
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    WaterChemicalSupplyPreventiveWorkPopupShow ?
                        <WaterChemicalSupplyPreventiveWorkPopup
                            open={WaterChemicalSupplyPreventiveWorkPopupShow}
                            // popupHeading="Water Quality-Chlorine"                        
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            DashProjectTypeId={DashProjectTypeId}
                            RoleID={RoleID}
                        />
                        : <></>
                }
            </div>
        </div>
    )
}